export interface GoogleViaFirebaseReadiness {
    GoogleProviderEnabled: boolean;
    AccountLinkingDisabled: boolean;
    AuthorizedDomains: string[];
    MissingAuthorizedDomains: string[];
    IsReady: boolean;
}

export interface GoogleViaFirebaseManagedStatus {
    Readiness: GoogleViaFirebaseReadiness;
    Problems: string[];
}

export interface FirebaseWebApp {
    AppId: string;
    DisplayName: string | null;
}

export enum FirebaseErrorKind {
    Unknown = '',
    InvalidCredential = 'invalid_credential',
    InsufficientPermissions = 'insufficient_permissions',
    ProjectUnreachable = 'project_unreachable',
}

export interface FirebaseError {
    Kind: FirebaseErrorKind;
    Message: string;
}

export enum AuthMethodType {
    Unknown = '',
    EmailWithPassword = 'email_with_password',
    DirectGoogle = 'direct_google',
    GoogleViaFirebase = 'google_via_firebase',
}

export enum AuthMethodHealthType {
    Unknown = '',
    Ok = 'ok',
    Disabled = 'disabled',
    Unhealthy = 'unhealthy',
}

export type AuthMethodHealth =
    | { type: AuthMethodHealthType.Disabled }
    | { type: AuthMethodHealthType.Ok }
    | { type: AuthMethodHealthType.Unhealthy; Messages: string[] };

export enum FirebaseProjectAccessType {
    Unknown = '',
    External = 'external',
    Managed = 'managed',
}

export enum GoogleViaFirebaseManagedCheckStatusType {
    Unknown = '',
    Completed = 'completed',
    Failed = 'failed',
    NotChecked = 'not_checked',
}

export type GoogleViaFirebaseManagedCheckStatus =
    | { type: GoogleViaFirebaseManagedCheckStatusType.Completed; Readiness: GoogleViaFirebaseReadiness }
    | { type: GoogleViaFirebaseManagedCheckStatusType.Failed; Error: FirebaseError }
    | { type: GoogleViaFirebaseManagedCheckStatusType.NotChecked };

export type GoogleViaFirebaseProjectAccessStatus =
    | { type: FirebaseProjectAccessType.External }
    | { type: FirebaseProjectAccessType.Managed; CheckStatus: GoogleViaFirebaseManagedCheckStatus };

export type AuthMethodStatus =
    | { type: AuthMethodType.DirectGoogle; Health: AuthMethodHealth }
    | { type: AuthMethodType.EmailWithPassword; Health: AuthMethodHealth }
    | { type: AuthMethodType.GoogleViaFirebase; Health: AuthMethodHealth; ProjectAccess: GoogleViaFirebaseProjectAccessStatus };

export type FirebaseProjectAccess =
    | { type: FirebaseProjectAccessType.External }
    | { type: FirebaseProjectAccessType.Managed };

export type AuthMethod =
    | { type: AuthMethodType.DirectGoogle; IsEnabled: boolean; ClientId: string }
    | { type: AuthMethodType.EmailWithPassword; IsEnabled: boolean }
    | { type: AuthMethodType.GoogleViaFirebase; IsEnabled: boolean; ProjectId: string; ApiKey: string; AuthDomain: string; AppId: string; ProjectAccess: FirebaseProjectAccess };

export interface AuthPreset {
    Id: string;
    Name: string;
    Description: string | null;
    IsPublic: boolean;
    Methods: AuthMethod[];
    CreatedAt: string;
    DeletedAt: string | null;
}

export type AuthMethodPreparationError =
    | { type: AuthMethodType.GoogleViaFirebase; Detail: FirebaseError };

export interface AuthPresetSummary {
    Id: string;
    Name: string;
    Description: string | null;
    IsPublic: boolean;
    IsDeleted: boolean;
}

export interface GoogleViaFirebaseManagedNotReady {
    Readiness: GoogleViaFirebaseReadiness;
    Problems: string[];
}
